import { observer } from "mobx-react-lite";
import type { AutomationConfig_SystemStatus } from "@smartsuite/automation-engine-api";
import { ErrorWrapper, StyledAutomationCardError } from "../style";
import { translateIfPresent } from "../../../../../locales/i18n";
import { Underscored } from "../../../../AutomationActivity/ActivityHeader/styles";
import { t } from "i18next";

export const AutomationCardError = observer<{
  systemStatus?: AutomationConfig_SystemStatus;
}>(({ systemStatus }) => {
  if (systemStatus?.systemStatus.oneofKind === "disabled") {
    return (
      <ErrorWrapper>
        <StyledAutomationCardError>
          {translateIfPresent(
            `automation-card.${systemStatus.systemStatus.disabled.message}`,
            systemStatus.systemStatus.disabled.message,
          )}
        </StyledAutomationCardError>
      </ErrorWrapper>
    );
  } else if (systemStatus?.systemStatus.oneofKind === "notPermitted") {
    return (
      <ErrorWrapper>
        <StyledAutomationCardError>
          {translateIfPresent(
            `caption.You do not have permissions to view and modify this automation`,
            `You do not have permissions to view and modify this automation`,
          )}
          &nbsp;
        </StyledAutomationCardError>
        <Underscored
          onClick={(e) => {
            e.stopPropagation();
            window.open(
              "https://help.smartsuite.com/en/collections/3584897-smartsuite-automations",
              "_blank",
            );
          }}
        >
          {t("learn-more2")}
        </Underscored>
      </ErrorWrapper>
    );
  }
  return <></>;
});
